// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-TbButton-styles___tbButton--RSr3m {
  border-radius: 6px;
  color: #4f84fa;
  text-align: center;
  border: 1px solid #3189fb;
  padding: 15px;
  font-size: 17px;
}
  .components-TbButton-styles___tbButton--RSr3m:hover {
    cursor: pointer;
  }
`, "",{"version":3,"sources":["webpack://./components/TbButton/styles.pcss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;AAIjB;EAHE;IACE,eAAe;EACjB","sourcesContent":[".tbButton {\n  border-radius: 6px;\n  color: #4f84fa;\n  text-align: center;\n  border: 1px solid #3189fb;\n  padding: 15px;\n  font-size: 17px;\n  &:hover {\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tbButton": `components-TbButton-styles___tbButton--RSr3m`
};
module.exports = ___CSS_LOADER_EXPORT___;
